import { getUser, updatePassword, updateSelfPassword } from '@/request/user';
import { getToken, setToken, setCookies, getCookies, removeCookies } from '@/utils/token';
import {
    login,
    doLogin,
    getMenuList,
    saveMenu,
    updateMenu,
    deleteMenu,
    changeMenuStatus,
    getRoleList,
    addRole,
    updateRole,
    deleteRole,
    changeRoleStatus,
    getMenuTree,
    saveRoleMenuAuth,
    getRoleMenuAuth,
    updateMenuSort,
    loginOut,
    weChatLogin,
    getWeChatToken,
    bindWeChat,
    sortRole
} from '@/request/system';
import { ElMessage } from 'element-plus';
import _ from 'lodash';
import { flatMenuList, renderMenuTree } from '@/utils/common';
export default {
    namespace: true,

    state: {
        token: getToken(),
        menuList: [],
        permissions: [],
        roleList: [],
        menuTree: [],
        cmenuTree: [],
        roleMenuList: [],
        tagViews: getCookies('tagViews') ? JSON.parse(getCookies('tagViews')) : [],
        tagRoutes: getCookies('tagRoutes') ? JSON.parse(getCookies('tagRoutes')) : [],
        isLogin: false,
        isUpdate: getCookies('flag') ? (getCookies('flag') == 'false' ? false : true) : true
    },

    mutations: {
        // 设置菜单列表
        SET_MENU_LIST(state, payload) {
            state.menuList = payload.menuList;
        },

        // 菜单树形
        SET_MENU_TREE(state, menuTree) {
            state.menuTree = menuTree;
        },

        SET_CMENU_TREE(state, cmenuTree) {
            state.cmenuTree = cmenuTree;
        },
        // 设置TOken
        SET_TOKEN(state, token) {
            state.token = token;
        },
        // 设置角色
        SET_ROLES(state, roles) {
            state.roles = roles;
        },
        // 设置权限
        SET_PERMISSIONS(state, permissions) {
            state.permissions = permissions;
        },

        SET_IS_LOGIN(state, isLogin) {
            state.isLogin = isLogin;
        },

        SET_IS_UPDATE(state, isUpdate) {
            state.isUpdate = isUpdate;
        },

        SET_TAG_VIEWS(state, tagView) {
            if (tagView) {
                state.tagViews.push(tagView);
                setCookies('tagViews', JSON.stringify(state.tagViews));
            }
        },

        SET_TAG_ROUTES(state, tagRoute) {
            if (tagRoute) {
                state.tagRoutes.push(tagRoute);
                setCookies('tagRoutes', JSON.stringify(state.tagRoutes));
            }
        },

        UPDATE_TAG_ROUTERS(state, tagRoute) {
            let tagRoutes = [...state.tagRoutes];
            state.tagRoutes = tagRoutes.map(item => {
                if (item.path == tagRoute.path) {
                    return {
                        ...tagRoute
                    };
                } else {
                    return item;
                }
            });
            setCookies('tagRoutes', JSON.stringify(state.tagRoutes));
        },

        SPLICE_TAG(state, index) {
            state.tagViews.splice(index, 1);
            state.tagRoutes.splice(index, 1);
            setCookies('tagViews', JSON.stringify(state.tagViews));
            setCookies('tagRoutes', JSON.stringify(state.tagRoutes));
        },

        RESET_TAG(state, { tagViews, tagRoutes }) {
            state.tagViews = tagViews;
            state.tagRoutes = tagRoutes;
        },

        SET_ROLE_LIST(state, roleList) {
            state.roleList = roleList;
        },
        SET_ROLE_MENU_LIST(state, roleMenuList) {
            state.roleMenuList = roleMenuList;
        }
    },

    actions: {
        async login({ commit }, form) {
            let res = await login(form);
            if (res?.code == 200) {
                if (res.data) {
                    const { token, forceChangePassword } = res.data;
                    setToken(token);
                    setCookies('flag', forceChangePassword == 1 ? false : true);
                    commit('SET_TOKEN', token);
                    commit('SET_IS_UPDATE', forceChangePassword == 1 ? false : true);
                    return res;
                }
            }
        },
        loginOut: async () => {
            let res = await loginOut();
            return res;
        },

        WECHAT_LOGIN: async ({ commit }, payload) => {
            let res = await weChatLogin(payload);
            if (res?.code == 200) {
                if (res.data) {
                    const { token, forceChangePassword } = res.data;
                    setToken(token);
                    setCookies('flag', forceChangePassword == 1 ? false : true);
                    commit('SET_TOKEN', token);
                    commit('SET_IS_UPDATE', forceChangePassword == 1 ? false : true);
                    return res;
                }
            }
            return res;
        },

        BIND_WECHAT: async ({ commit }, payload) => {
            let res = await bindWeChat(payload);
            return res;
        },

        GET_ACCESS_TOKEN: async ({ commit }, payload) => {
            let res = await getWeChatToken(payload);
            return res;
        },

        async doLogin() {
            let res = await doLogin();
            return res;
        },

        updateMenuList: ({ commit }, payload) => {
            commit('SET_MENU_LIST', payload);
        },
        updateRoleList: ({ commit }, { roleList }) => {
            commit('SET_ROLE_LIST', roleList);
        },

        setUpdate: async ({ commit }, payload) => {
            commit('SET_IS_UPDATE', payload);
        },

        async loginout({ commit }) {
            commit('SET_TOKEN', res.token);
        },

        updatePassword: async ({ commit }, payload) => {
            let res = await updatePassword(payload);
            if (res?.code == 200) {
                ElMessage.success('密码更新成功');
                return res;
            }
        },

        updateSelfPassword: async ({ commit }, payload) => {
            let res = await updateSelfPassword(payload);
            if (res?.code == 200) {
                ElMessage.success('密码更新成功');
                commit('SET_IS_UPDATE', true);
                removeCookies('flag');
                setCookies('password', payload.password);
                return res;
            }
        },

        createTag: async ({ commit }, { tagView, tagRoute }) => {
            commit('SET_TAG_ROUTES', tagRoute);
            if (!_.isEmpty(tagRoute)) {
                commit('SET_TAG_VIEWS', tagView);
            }
        },

        updateTag: async ({ commit }, { tagRoute }) => {
            commit('UPDATE_TAG_ROUTERS', tagRoute);
        },

        deleteTag: async ({ commit }, $index) => {
            commit('SPLICE_TAG', $index);
        },

        resetTag: async ({ commit }, { tagViews, tagRoutes }) => {
            commit('RESET_TAG', { tagViews, tagRoutes });
        },

        async loginSuc({ commit }, isLogin) {
            commit('SET_IS_LOGIN', isLogin);
        },

        async getMenuList({ commit }, payload) {
            let res = await getMenuList(payload);
            if (res?.code == 200) {
                commit('SET_MENU_LIST', { menuList: res.data });
                return res;
            }
        },

        // 保存菜单
        saveMenu: async ({ commit, dispatch }, payload) => {
            let res = await saveMenu(payload);
            return res;
        },
        // 修改菜单
        updateMenu: async ({ commit, dispatch }, payload) => {
            let res = await updateMenu(payload);
            return res;
        },
        // 批量修改排序
        updateMenuSort: async ({}, payload) => {
            let res = await updateMenuSort(payload);
            return res;
        },
        // 删除菜单
        deleteMenu: async ({}, payload) => {
            let res = await deleteMenu(payload);
            return res;
        },
        // 切换状态
        changeMenuStatus: async ({}, { menuId, status }) => {
            let res = await changeMenuStatus(menuId, status);
            return res;
        },

        // 菜单树形
        getMenuTree: async ({ commit }) => {
            let res = await getMenuTree();
            if (res?.code == 200) {
                let list = res.data.filter(item => item);
                commit('SET_MENU_TREE', list);
                commit('SET_CMENU_TREE', renderMenuTree(res.data ?? []));
                commit('SET_ROLE_MENU_LIST', flatMenuList(res.data ?? []));
                return res;
            }
        },

        // 角色列表
        getRoleList: async ({ commit }, payload) => {
            let res = await getRoleList(payload);
            if (res?.code == 200) {
                function flatList(list) {
                    return list
                        .map(item => {
                            return {
                                ...item
                            };
                        })
                        .sort((a, b) => a.sort - b.sort);
                }
                commit('SET_ROLE_LIST', flatList(res.data));
                return res;
            }
        },
        // 新增角色
        saveRole: async ({ dispatch }, payload) => {
            let res = await addRole(payload);
            return res;
        },
        updateRole: async ({ dispatch }, payload) => {
            let res = await updateRole(payload);
            return res;
        },

        deleteRole: async ({ dispatch }, payload) => {
            let res = await deleteRole(payload);
            return res;
        },

        changeRoleStatus: async ({ dispatch }, { roleId, status }) => {
            let res = await changeRoleStatus(roleId, status);
            return res;
        },

        saveRoleMenuAuth: async ({}, payload) => {
            let res = await saveRoleMenuAuth(payload);
            return res;
        },

        getRoleMenuAuth: async ({}, payload) => {
            let res = await getRoleMenuAuth(payload);
            return res;
        },

        SORT_ROLE: async ({}, payload) => {
            let res = await sortRole(payload);
            return res;
        },

        async getUserRoutes() {},

        async saveAreaLInk({ commit }, params) {
            console.log(params);
        },

        getAreaTree: async () => {}
    }
};
